

export const SERVERS = [
  {
    id: 1,
    url: 'https://saviya-x-mini-production.up.railway.app',
    proxyBase: '/proxy/s1',
    label: 'Server 01',
    region: 'EU-WEST',
  },
  {
    id: 2,
    url: 'https://saviya-x-mini2-production.up.railway.app',
    proxyBase: '/proxy/s2',
    label: 'Server 02',
    region: 'SOUTHEAST-ASIA',
  },
  
  { id: 3, url: 'https://saviya-x-mini3-production.up.railway.app', proxyBase: '/proxy/s3', label: 'Server 03', region: 'US-WEST' },
  { id: 4, url: 'https://saviya-x-server.koyeb.app', proxyBase: '/proxy/s4', label: 'Server 04', region: 'EU-DE-FRA' },
]
